import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
// import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faInfoCircle, faQrcode, faList
} from '@fortawesome/free-solid-svg-icons';
import './DocSure.css';
// import docsureimage from '../../assets/pageimages/DocSure.png';
import { logout } from "../../redux/actions/authActions";

function DocSureHome() {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("MediFinders");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  return (
    <div className='bg-black text-white [&_p]:text-white p-2'>
      <header className="sticky top-0 z-50 bg-black border-b border-blue-400 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-yellow-200">📑🛡️ DocSure</div>
          <div className="text-xs text-white">हमेशा docSure@Think5Whys से पूछो!</div>          
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs lg:text-sm text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="w-8 mt-2 px-2 py-1 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="w-18 px-2 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                🔐 
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-2xl text-teal-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-teal-300 text-xs lg:text-sm font-medium">{userName}</div>
                <div className="flex gap-3">
                  <button
                    onClick={handleLogout}
                    className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                  >
                    ⏻
                  </button>
                </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-teal-300">🔐</Link>
            </div>
          )}
        </div>
      )}
      <div className="flex flex-col min-h-screen bg-black mt-2">        
        <div>
          {/* <div className="image-container flex justify-center my-4">
            <div className="relative border border-gray-300 w-1/3">
              <img id="docsure-id" src={docsureimage} alt="DocSure Image" className="w-full h-auto" />
            </div>
          </div> */}

          <div className="mt-4 border border-gray-300 rounded-lg shadow-md flex justify-center space-x-4 bg-black py-3 rounded-t-lg">
              <Link to="/docsure-create" className="ml-2 mr-2 top-button-link text-white font-semibold py-2 px-4 rounded-lg flex items-center space-x-2 transition duration-300 ease-in-out">
                <FontAwesomeIcon icon={faQrcode} className="text-lg" />
                <span>Create</span>
              </Link>

              <Link to="/docsure-archived" className="ml-2 mr-2 top-button-link  text-white font-semibold py-2 px-4 rounded-lg flex items-center space-x-2 transition duration-300 ease-in-out">
                <FontAwesomeIcon icon={faList} className="text-lg" />
                <span>Archive</span>
              </Link>

              <Link to="/docsure-accessed" className="ml-2 mr-2 top-button-link  text-white font-semibold py-2 px-4 rounded-lg flex items-center space-x-2 transition duration-300 ease-in-out">
                <FontAwesomeIcon icon={faQrcode} className="text-lg" />
                <span>Access</span>
              </Link>

              <Link to="/docsure-activities" className="ml-2 mr-2 top-button-link text-white font-semibold py-2 px-4 rounded-lg flex items-center space-x-2 transition duration-300 ease-in-out">
                <FontAwesomeIcon icon={faQrcode} className="text-lg" />
                <span>Activities</span>
              </Link>
          </div>

          <div className="p-4 bg-black rounded-lg shadow-md mb-2">
            <div className="text-white text-xl font-bold mb-4 flex items-center space-x-2">
              <FontAwesomeIcon icon={faInfoCircle} className="text-lg lg:text-xl text-yellow-400" />
              <span>About DocSure@Think5Whys</span>
            </div>

            <section className="mb-2">
              <h4 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">Document Process</h4>
              <p className="text-gray-200 mb-2 text-xs lg:text-sm ">A. Create, B. Archive, C. Access, D. Activities Log, E. Change (Optional)</p>

              <div className="pl-4 text-gray-300">
                <h5 className="font-bold text-yellow-300 mb-1 text-sm lg:text-lg">A. Create:</h5>
                <ul className="list-disc text-xs lg:text-sm ml-6 space-y-1 [&_li]:text-gray-100">
                  <li>New (Title, Description, Access List)</li>
                  <li>Upload (PDF, Image, Multipart)</li>
                  <li>Draft (Template, Custom, AI-Created)</li>
                  <li>Pay</li>
                  <li>Sign (Self / Third Party Verification)</li>
                  <li>Digital Stamp (Authorized Vendor)</li>
                </ul>
              </div>
            </section>

            <section className="pl-5 mb-2">
              <h5 className="font-bold text-yellow-300 mb-1 text-sm lg:text-lg">B. Archive:</h5>
              <ul className="list-disc ml-6 text-gray-300 space-y-1 [&_li]:text-gray-100 text-xs lg:text-sm">
                <li>Share View Access Token</li>
                <li>Encryption (Cypher)</li>
                <li>Blockchain Tamper Proof</li>
                <li>Instant Authorization</li>
              </ul>
            </section>

            <section className="pl-5 mb-6">
              <h5 className="font-bold text-yellow-300 mb-1 text-sn lg:text-lg">C. Access:</h5>
              <ul className="list-disc ml-6 text-gray-300 space-y-1 [&_li]:text-gray-100 text-xs lg:text-sm">
                <li>Self Access (View/Download)</li>
                <li>Third Party API Access</li>
              </ul>
            </section>

            <section className="pl-5 mb-6">
              <h5 className="font-bold text-yellow-300 mb-1 text-sm lg:text-lg">D. Activities Log:</h5>
              <ul className="list-disc ml-6 text-gray-300 space-y-1 [&_li]:text-gray-100 text-xs lg:text-sm">
                <li>Document Life Cycle (State Machine)</li>
                <li>Access Logs (Owner / Third Party)</li>
              </ul>
            </section>

            <section>
              <h5 className="pl-5 font-bold text-yellow-300 mb-1 text-sm lg:text-lg">E. Change:</h5>
              <ul className="list-disc ml-6 text-gray-300 space-y-1 [&_li]:text-gray-100 text-xs lg:text-sm">
                <li>Document Life Cycle Management</li>
                <li>Access Logs (Owner / Third Party)</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
      <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="mx-auto px-1 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-xs lg:text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default DocSureHome;
